import SwipeIcon from './SwipeIcon';

export default SwipeIcon;
